import React from 'react'
import View from './view.js'

export default function Logic(props) {
  return (
    <div {...props} ref={props.innerRef}>
      <View
        {...props}
        dragHandleProps={props.dragHandleProps}
        viewPath={props?.dsViewPath || props.viewPath}
      />
    </div>
  )
}
